import React, { useState, useEffect } from "react";
import CookieConsent from "react-cookie-consent";

import LanguageSelector from "./components/LanguageSelector";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { WelshContext } from "./useWelsh";
import * as classes from "./Root.module.css";

const Root = ({ children }) => {
  const [welsh, setWelsh] = useState(false);

  // useEffect(() => {
  //   if (welsh !== undefined)
  //     localStorage.setItem("language", welsh ? "welsh" : "english");
  // }, [welsh]);

  return (
    <WelshContext.Provider value={welsh}>
      <CookieConsent cookieName="viewed_cookie_policy">
        {welsh
          ? "Mae'r wefan hon yn defnyddio cwcis i wella profiad y defnyddiwr"
          : "This website uses cookies to enhance the user experience"}
      </CookieConsent>
      {/* <LanguageSelector setWelsh={setWelsh} /> */}
      <div className={classes.app}>
        <Header setWelsh={setWelsh} />
        {children}
        <div className={classes.grow} />
        <Footer />
      </div>
    </WelshContext.Provider>
  );
};

export default Root;
